import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { attachmentsKeys } from './queryKeys';
import { fetchBuildingPhotos, attachBuildingPhoto } from '../services/AttachmentsService';
export function useBuildingPhotos(proposalId, url, enabled) {
    return useQuery({
        queryKey: attachmentsKeys.buildingPhotos(proposalId),
        queryFn: () => fetchBuildingPhotos(url),
        enabled,
        staleTime: 60 * 1000
    });
}
export function useAttachBuildingPhoto(proposalId, attachUrl) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ photoType, photoId }) => attachBuildingPhoto(attachUrl, photoType, photoId),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.list(proposalId) });
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.buildingPhotos(proposalId) });
        }
    });
}
